import { createSlice } from "@reduxjs/toolkit";
import { RoleUtils, ROLES } from "../constants/roles";

const initialState = {
  // User information
  user: {
    id: null,
    name: null,
    email: null,
  },
  
  // Authentication state
  isAuthenticated: false,
  token: null,
  
  // Role and permissions
  role: null,
  permissions: [],
  
  // Legacy support (will be deprecated)
  isSuperAdmin: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      const { permissions, name, email, isSuperAdmin, userId, token } = action.payload;
      
      // User information
      state.user = {
        id: userId || state.user.id,
        name: name || state.user.name,
        email: email || state.user.email,
      };
      
      // Authentication state
      state.isAuthenticated = true;
      state.token = token || state.token;
      
      // Role and permissions
      state.permissions = permissions || [];
      state.role = RoleUtils.getRoleFromPermissions(permissions);
      
      // Legacy support
      state.isSuperAdmin = isSuperAdmin || state.role === ROLES.SUPER_ADMIN;
    },
    
    clearAuth: (state) => {
      return { ...initialState };
    },
    
    updatePermissions: (state, action) => {
      state.permissions = action.payload;
      state.role = RoleUtils.getRoleFromPermissions(action.payload);
      state.isSuperAdmin = state.role === ROLES.SUPER_ADMIN;
    },
  },
});

// Action creators
export const { setAuth, clearAuth, updatePermissions } = authSlice.actions;

// Selectors
export const selectAuth = (state) => state.auth;
export const selectUser = (state) => state.auth.user;
export const selectRole = (state) => state.auth.role;
export const selectPermissions = (state) => state.auth.permissions;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectIsSuperAdmin = (state) => state.auth.isSuperAdmin;

// Role-based selectors
export const selectIsAdmin = (state) => RoleUtils.isAdminLevel(state.auth.role);
export const selectIsSeller = (state) => RoleUtils.isSellerLevel(state.auth.role);
export const selectIsServiceProvider = (state) => RoleUtils.isServiceLevel(state.auth.role);
export const selectDashboardRoute = (state) => RoleUtils.getDashboardRoute(state.auth.role);

export default authSlice.reducer;
